import { useQuery } from '@tanstack/react-query';

import Axios from 'axios';
import { queryClient } from 'QueryClientProvider';

const onGetProjectStatements = (ID, statementType) =>
    Axios.get(`/projects/StatementsGroupedByContact/${statementType}/${ID}`);

const useProjectStatements = (ID, statementType) => {
    return useQuery({
        queryKey: ['projectstatements', ID, { statementType: statementType }],
        queryFn: () => onGetProjectStatements(ID, statementType),
        staleTime: 10000,
        cacheTime: 10000,
        retry: false,
    });
};

const forceReloadProjectStatements = (ID) => {
    return queryClient.invalidateQueries({ queryKey: ['projectstatements', ID] });
};

export { useProjectStatements, forceReloadProjectStatements };
